import { StyledFormField } from '@/components/styles'
import { useFormContext } from 'react-hook-form'
import { useState, useEffect, useRef } from 'react'
import { formErrors } from '@/lib/config'

function getErrorMessage(name, error) {
  if (!error) return ''

  const fieldErrors = formErrors[name]
  return (fieldErrors && fieldErrors[error.type]) || formErrors.default[error.type] || error.message || ''
}

const FormField = props => {
  const {
    label,
    name,
    validateRules = {},
    inputAs,
    type = 'text',
    inputmode = 'text',
    autoComplete,
    autoFocus,
    placeholder,
  } = props

  const { errors, getValues, register, triggerValidation } = useFormContext()
  const [focused, setFocused] = useState(false)
  const inputRef = useRef()
  const validateOnChange = useRef(false)

  useEffect(() => {
    let timeoutId
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        inputRef.current.focus()
      }, 400)
    }

    return () => clearTimeout(timeoutId)
  }, [])

  const error = errors[name]
  const errorMessage = getErrorMessage(name, error)
  const hasError = !!errorMessage
  const value = getValues()[name] || ''
  const hasValue = !!value.trim()

  return (
    <div>
      <StyledFormField focused={focused} hasError={hasError} hasValue={hasValue}>
        <StyledFormField.Label>{label}</StyledFormField.Label>

        <StyledFormField.Input
          as={inputAs}
          name={name}
          type={type}
          inputMode={inputmode}
          autoComplete={autoComplete}
          ref={e => {
            register(e, validateRules)
            inputRef.current = e
          }}
          onFocus={() => {
            setFocused(true)
          }}
          onBlur={() => {
            setFocused(false)
            if (name !== 'phone') return
            validateOnChange.current = true
            triggerValidation(name)
          }}
          onChange={() => {
            if (!validateOnChange.current) return
            triggerValidation(name)
          }}
          placeholder={placeholder}
        />
      </StyledFormField>

      {hasError && <StyledFormField.Error>{errorMessage}</StyledFormField.Error>}
    </div>
  )
}

export default FormField
